import axios from '@/utils/request.js'

export const getDepartInfo = (params) => {
  // 获取部门信息
  return axios.post('/goods/gas/department/getGroupDetail', params)
}

export const searchGoods = (params) => {
  // 送货搜索
  return axios.post('/goods/bGlmCustomer/page', params)
}
export const getCustomerListByDeptId = (params) => {
  // 送货搜索
  return axios.post('/goods/bGlmCustomer/getCustomerListByDeptId', params)
}
export const getCyScanInfo = (params) => {
  // 送货扫码
  return axios.post('/goods/gas/cylinder/getCyScanInfo', params)
}
export const getCyScanInfoContainGroup = (params) => {
  // 送货扫码
  return axios.post('/goods/gas/cylinder/getCyScanInfoContainGroup', params)
}
export const AgentSendGoodsWithoutOrder = (params) => {
  // 送货 送货确认
  return axios.post('/goods/gas/order/AgentSendGoodsWithoutOrder', params)
}
export const userReceiveCylinder = (params) => {
  // 送货 返瓶确认
  return axios.post(
    '/goods/gas/returnOrder/AgentReceiveCylinderWithoutOrder',
    params
  )
}

export const getAgentOrderList = (params) => {
  // 订单列表
  return axios.post('/goods/gas/order/getAgentOrderList', params)
}

export const AgentSendGoodsByOrder = (params) => {
  // 订单送货确认
  return axios.post('/goods/gas/order/AgentSendGoodsByOrder', params)
}
export const AgentReceiveCylinderByOrder = (params) => {
  // 订单返瓶确认
  return axios.post(
    '/goods/gas/returnOrder/AgentReceiveCylinderByOrder',
    params
  )
}
export const getLastCheckDate = (params) => {
  // 检查时间
  return axios.post('/goods/gas/bGlmCheckresult/getLastCheckDate', params)
}
export const submitCheck = (params) => {
  // 提交检查结果
  return axios.post('/goods/gas/bGlmCheckresult/commitCheckResult', params)
}
export const getCheckStatisticsMess = (deptId) => {
  // 检查情况统计
  return axios.post('/goods/gas/bGlmCheckresult/getCheckStatisticsMess', {
    deptId
  })
}

export const getNoticeStatisticsMess = (deptId) => {
  // 通知阅读情况
  return axios.post('/admin/jzl/bGlmNotice/getNoticeStatisticsMess', {
    deptId
  })
}
export const getNotCheckListByDeptId = (deptId) => {
  // 未检查用户列表
  return axios.get(
    `/goods/gas/bGlmCheckresult/getNotCheckListByDeptId/${deptId}`
  )
}
export const getSpecialCheckListByUserId = (userId) => {
  // 根据用户查询专项检查列表
  return axios.post('/goods/gas/bGlmCheck/getSpecialCheckListByUserId', {
    userId
  })
}
export const getCheckInfoById = (params) => {
  // 查询具体的题目
  return axios.post('/goods/gas/bGlmCheck/getCheckInfoById', params)
}
export const getCheckResultInfoMess = (crId) => {
  // 检查结果
  return axios.post('/goods/gas/bGlmCheckresult/getCheckResultInfoMess', {
    crId
  })
}
export const getDetailListByComId = (comid) => {
  // 检查结果列表
  return axios.get(`/goods/gas/bGlmCheckresult/getDetailListByComId/${comid}`)
}
export const getAllCheckResultByUserId = (userId) => {
  // 检查
  return axios.post('/goods/gas/bGlmCheckresult/getAllCheckResultByUserId', {
    userId
  })
}

export const agentFillApply = (params) => {
  // 充装
  return axios.post('/goods/gas/cylinder/agentFillApply', params)
}
